import React from 'react'

export const TopNavMenuItemContent = ({ content }: { content: string }) => (
  <div className="hidden text-sm text-grey-600 lg:inline-block">{content}</div>
)
